/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: FeatureException.ts
 * Project: mle-client-n
 * Committed last: 2022/1/10 @ 1818
 * ---
 * Description:
 */

import {Feature} from './Feature';

export class FeatureException extends Error {
  readonly feature: Feature<any, any, any>;

  constructor(message: string, feature: Feature<any, any, any>) {
    super(`FeatureException: ${message} ${feature.featureName} . \nFeature: ${feature}`);
    this.feature = feature;
  }
}